import __vue_component__ from './IconWrapper.vue.js';

var NotificationDirectIcon = {
  name: 'NotificationDirectIcon',
  props: {
    size: {
      type: String
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    }
  },

  render(h) {
    // eslint-disable-next-line max-len
    return h(__vue_component__, {
      props: { ...this.$props
      },
      domProps: {
        innerHTML: '<svg viewBox="0 0 24 24"><path d="M6.586 17.829a2 2 0 0 0 2.829 0L6.585 15a2 2 0 0 0 0 2.829zm4.798-12.351A5.036 5.036 0 0 1 14.954 4c.972 0 1.945.28 2.788.839.02-.026.043-.05.066-.074a1.01 1.01 0 1 1 1.354 1.494 5.048 5.048 0 0 1-.64 6.356l-.725.725c-.782.783-1.813 2.21-2.312 3.207l-1.509 3.016c-.249.5-.773.584-1.171.187l-8.556-8.555c-.397-.397-.308-.924.187-1.172l3.017-1.508c.989-.494 2.42-1.526 3.206-2.312l.725-.725zm2.739 9.63c.517-.975 1.568-2.396 2.354-3.182l.725-.726a3.048 3.048 0 0 0 .387-3.835c-.19-.286-.718-.766-.859-.86A3.043 3.043 0 0 0 15.047 6a3.04 3.04 0 0 0-2.156.892l-.95.951c-.784.785-2.219 1.82-3.201 2.311l-1.74.87 6.07 6.069 1.053-1.985z" fill="currentColor" fill-rule="evenodd"/></svg>'
      }
    });
  }

};

export default NotificationDirectIcon;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/NotificationDirectIcon.js